import type {
  SegmentStateBookingPanel,
  SegmentBookingPanel,
} from '@web-platform/shared-universal-types/src/redux/state/shared/flightBookingPanel/entities/flights/segmentsBookingPanel';

export const get = (state: SegmentStateBookingPanel, id: string): SegmentBookingPanel =>
  state.byId[id];
export const all = (state: SegmentStateBookingPanel): Record<string, SegmentBookingPanel> =>
  state.byId;
